<template>
    <div class="container-fluid default-dashboard pt-2">
        <div class="row">
            <div class="proorder-xxl-1 col-md-4 box-col-12">
                <WelcomeView />
            </div>
            <div class="proorder-xxl-1 col-md-8 box-col-12">
                <div class="row">
                    <div class="col-md-6">
                        <div class="card text-center m-2">
                            <div class="card-body">
                                <h5 class="card-title display-6">{{ stats[0].label }}</h5>
                                <p class="card-text display-5">{{ formatSeparator(stats[0].value) }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card text-center m-2">
                            <div class="card-body">
                                <h5 class="card-title display-6">{{ stats[1].label }}</h5>
                                <p class="card-text display-5">{{ formatSeparator(stats[1].value) }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="card text-center m-2">
                            <div class="card-body">
                                <h5 class="card-title display-6">{{ stats[2].label }}</h5>
                                <p class="card-text display-5">{{ formatSeparator(stats[2].value) }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-md-8">
                <Card1 colClass="col-xxl-12 col-xl-12 proorder-xxl-12 col-lg-12 col-md-12 box-col-12" cardClass="card"
                    cardhaderClass="card-no-border pb-0" header="true" title="Transaction History"
                    cardbodyClass="transaction-history pt-0">
                    <div class="table-responsive theme-scrollbar">
                        <DataTable :headers="headers" :items="orderHistory" :selectable="true"  :loading="loading" :total="total"
                            :params="params" @update:params="updateParams">
                            <template #item.code="{ item }"
                                style="white-space: nowrap;word-wrap: break-word;">
                                <a href="javascript:void(0)" @click="openInvoiceModal(item as any)"
                                    class="text-decoration-none">
                                    <i class="fa fa-solid fa-print"></i>
                                    {{ item.code }}
                                </a>
                            </template>
                            <template #item.transaction_date="{ item }"
                                style="white-space: nowrap;word-wrap: break-word;">
                                <a href="javascript:void(0)" @click="informationOrder(item)"
                                    class="text-decoration-none">
                                    <i class="fa fa-upload"></i>
                                    {{ formatDateTime(item.transaction_date) }}
                                </a>
                            </template>
                            <template #item.divisi="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                                item.divisi_team_name }}</template>
                            <template #item.customer="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                                item.customer_name }} ({{ item.customer_phone }})</template>
                            <template #item.qty_total="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                                item.qty_total }}</template>
                            <template #item.grand_total="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{ formatCurrency(item.grand_total) }}</template>
                        </DataTable>
                    </div>
                </Card1>
            </div>
            <div class="col-md-4">
                <Card1 colClass="col-12" cardClass="card" cardhaderClass="card-no-border pb-0" header="true"
                    title="Top Sales" headerTop="true" down="false" cardbodyClass="top-user pt-2" haderTitle="true">
                    <ul>
                        <li class="d-flex align-items-center justify-content-between gap-2"
                            v-for="(item, index) in user" :key="index">
                            <div class="d-flex gap-2 py-1">
                                <div class="flex-shrink-0 comman-round">
                                    <span
                                        class="text-white rounded-circle d-flex align-items-center justify-content-center">{{
                                            item.sales_name }}</span>
                                    <!-- <img :src="item.sales.avatarurl"
                                        style="max-width: 3rem;" :alt="item.sales_name" /> -->
                                </div>
                                <div>
                                    <a href="#">
                                        <h6>{{ item.sales_name }}</h6>
                                    </a>
                                    <p>Order: {{ formatSeparator(item.total_orders) }} ({{
                                        formatSeparator(item.total_qty) }})</p>
                                </div>
                            </div>
                            <button class="btn " :class="item.class">{{ formatCurrency(item.grand_total) }}</button>
                        </li>
                    </ul>
                </Card1>
            </div>
        </div>
    </div>

    <!-- Bootstrap Modal for Add/Edit -->
    <div v-i class="modal fade" id="orderModal" tabindex="-1" ref="modalRef">
        <div class="modal-dialog modal-lg"> <!-- {{ Make modal larger for more fields }} -->
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ selectedOrder.code }} ({{ selectedOrder.order_status }})</h5>
                    <button type="button" class="btn-close" @click="closeModal"></button>
                </div>
                <div class="modal-body col-12">
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Order Code</label>
                            <input v-model="selectedOrder.code" type="text" class="form-control" disabled>
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Transaction Date</label>
                            <input :value="formatDateTime(selectedOrder.transaction_date)" type="text"
                                class="form-control" disabled>
                        </div>
                    </div>
                    <div class="mb-2">
                        <label class="form-label col-form-label">Customer</label>
                        <input v-if="selectedOrder.customer"
                            :value="selectedOrder.customer_name + ' ' + selectedOrder.customer_phone" type="text"
                            class="form-control" disabled>
                    </div>
                    <div class="mb-2">
                        <label class="form-label col-form-label">Customer Address</label>
                        <textarea v-if="selectedOrder.customer" v-model="selectedOrder.customer_address" rows="3"
                            class="form-control" disabled />
                    </div>
                    <div class="mb-2">
                        <label class="form-label col-form-label">Location</label>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-muted">Koordinat</div>
                                <div v-if="selectedOrder.locations" class="fw-semibold">{{ selectedOrder.locations }}</div>
                                <div v-else class="text-muted">Belum dipilih</div>
                            </div>
                            <div class="d-flex align-items-center">
                                <a v-if="selectedOrder.locations" class="btn btn-sm btn-outline-secondary me-2"
                                    :href="'https://www.google.com/maps?q=' + selectedOrder.locations" target="_blank"
                                    rel="noopener noreferrer">
                                    Open
                                </a>
                                <button class="btn btn-sm btn-outline-primary" @click="openLocationModal">
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4" style="overflow-y: auto;">
                        <h6>Order Items</h6>
                        <table class="table table-sm" v-if="selectedOrder.ID && selectedOrder.order_details.length > 0">
                            <thead>
                                <tr>
                                    <th>Produk</th>
                                    <th style="text-align:end">Qty</th>
                                    <th style="text-align:end">Harga</th>
                                    <th style="text-align:end">Diskon</th>
                                    <th style="text-align:end">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in selectedOrder.order_details" :key="item.productId">
                                    <td>{{ item.name }}</td>
                                    <td style="text-align:end">{{ formatSeparator(item.quantity) }}</td>
                                    <td style="text-align:end">{{ formatCurrency(item.price) }}</td>
                                    <td style="text-align:end">{{ formatCurrency(item.discount) }}</td>
                                    <td style="text-align:end">{{ formatCurrency(item.total) }}</td>
                                </tr>
                                <tr>
                                    <td colspan="2" style="text-align:start; border: 0;"> <label v-if="selectedOrder?.bank">
                                            Payment
                                            to : {{ selectedOrder.bank.name }} - {{
                                                selectedOrder.bank_account_number }}/{{
                                                selectedOrder.bank_account_name }}</label></td>
                                    <td colspan="2" style="text-align:end; border: 0;">Shipping Cost</td>
                                    <td style=" text-align:end; border: 0;">{{
                                        formatCurrency(selectedOrder.shipping_cost)
                                    }}</td>
                                </tr>
                                <tr>
                                    <td style="text-align:start; border: 0;">Sales : {{ selectedOrder.sales_name }}</td>
                                    <td colspan="3" style="text-align:end; border: 0;">Other Fee</td>
                                    <td style="text-align:end; border: 0;">{{ formatCurrency(selectedOrder.fee_amount)
                                    }}
                                    </td>
                                </tr>
                                <tr>
                                    <td v-if="selectedOrder.order_status == 'APPROVED'"
                                        style="text-align:start; border: 0;">Admin : {{ selectedOrder.approval_by }}
                                    </td>
                                    <td v-else-if="selectedOrder.order_status == 'REJECTED'"
                                        style="text-align:start; border: 0;">Admin : {{ selectedOrder.reject_by }}</td>
                                    <td v-else-if="selectedOrder.order_status == 'CANCELLED'"
                                        style="text-align:start; border: 0;">Admin : {{ selectedOrder.cancel_by }}
                                    </td>
                                    <td v-else style="text-align:start; border: 0;">{{ selectedOrder.order_status
                                    }}
                                    </td>
                                    <td colspan="3" style="text-align:end; border: 0;">Grand Total</td>
                                    <td style="text-align:end; border: 0;"><b>{{
                                        formatCurrency(selectedOrder.grand_total)
                                            }}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-else>No items found for this order.</p>
                    </div>
                    <div class="row">
                        <div class="row col-md-6">
                            <div class="mb-2">
                                <label class="form-label col-form-label">Note</label>
                                <textarea v-model="selectedOrder.order_status_note" col="3" class="form-control"
                                    disabled />
                            </div>
                        </div>

                        <div class="row col-md-5">
                            <div class="mb-2">
                                <label class="form-label me-4 mb-0" style="white-space: nowrap;">Upload Transfer</label>
                                <Upload v-if="selectedOrder.order_status == 'PENDING'" pathFile="/sales"
                                    @on-success="(event: string) => handleImageUpload(event)"
                                    @on-change="(event: string) => handleImageUpload(event)"></Upload>
                                <div v-if="selectedOrder.payment_image" class="mt-2">
                                    <img :src="selectedOrder.payment_image" alt="Preview"
                                        style="max-width: 400px; max-height: 400px;">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button v-if="selectedOrder.order_status == 'PENDING'"  type="button" class="btn btn-danger" @click="closeModal">Cancel</button>
                    <button v-if="selectedOrder.order_status == 'PENDING'"  type="submit" class="btn btn-warning" @click="processOrder">Process</button>
                    <button type="button" class="btn btn-success" @click="printWa">WA</button>
                </div>
            </div>
        </div>
    </div>

    <div v-if="showLocationModal" class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Update Location</h5>
                    <button type="button" class="btn-close" @click="closeLocationModal"></button>
                </div>
                <div class="modal-body">
                    <div class="row g-2">
                        <div class="col-12">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <div class="text-muted">Koordinat terpilih</div>
                                    <div v-if="tempLat != null && tempLng != null" class="fw-semibold">
                                        {{ tempLat }}, {{ tempLng }}
                                    </div>
                                    <div v-else class="text-muted">Klik peta atau cari alamat</div>
                                </div>
                                <button class="btn btn-outline-secondary btn-sm" @click="centerToTemp"
                                    :disabled="tempLat == null || tempLng == null">
                                    Center
                                </button>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="addressQuery"
                                    placeholder="Cari alamat...">
                                <button class="btn btn-outline-primary" @click="searchAddress"
                                    :disabled="!addressQuery || !googleMapsApiKey">
                                    Search
                                </button>
                            </div>
                        </div>
                        <div class="col-12" v-if="googleMapsApiKey">
                            <GoogleMap :api-key="googleMapsApiKey" style="width: 100%; height: 420px"
                                :center="mapCenter" :zoom="mapZoom" @click="onMapClick">
                                <Marker v-if="tempLat != null && tempLng != null"
                                    :options="{ position: { lat: tempLat, lng: tempLng } }" />
                            </GoogleMap>
                        </div>
                        <div class="col-12" v-else>
                            <div class="alert alert-warning mb-0">
                                Google Maps API Key belum diset.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeLocationModal">Close</button>
                    <button type="button" class="btn btn-primary" @click="applyLocation">Use Location</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade" :class="{ 'show': showLocationModal }" v-if="showLocationModal"></div>

    <!-- Bootstrap Modal for Invoice -->
    <div class="modal fade" id="invoiceModal" tabindex="-1" ref="invoiceModalRef">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Invoice - {{ invoiceForm.code }}</h5>
                    <button type="button" class="btn-close" @click="closeInvoiceModal"></button>
                </div>
                <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
                    <div id="invoice-content" class="invoice-container">
                        <!-- Header with teal background -->
                        <div class="invoice-header-bg">
                            <div class="invoice-header-content">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="invoice-title-section">
                                        <h1 class="invoice-main-title">INVOICE</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Invoice details section -->
                        <div class="invoice-details-section">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="invoice-info-left">
                                        <p class="invoice-number"><strong>Invoice Number:</strong> {{ invoiceForm.code }}</p>
                                        <p class="invoice-date"><strong>Invoice Date:</strong> {{ formatDate(invoiceForm.transaction_date) }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6 text-end">
                                    <div class="company-details">
                                        <img src="/gdn.png" alt="Gudang Dunia" class="company-logo-img" style="max-height: 100px; max-width: 200px; object-fit: contain;">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Bill To Section -->
                        <div class="bill-to-section">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="client-info">
                                        <p class="client-name"><strong>Customer: {{ invoiceForm.customer_name }}</strong></p>
                                        <p class="phone"><strong>Phone:</strong> {{ invoiceForm.customer_phone }}</p>
                                        <p class="billing-address"><strong>Billing Address:</strong> {{ invoiceForm.customer_address }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div v-if="invoiceForm.bank_name" class="payment-info">
                                        <h4>Payment Information:</h4>
                                        <p><strong>Bank:</strong> {{ invoiceForm.bank_name }}</p>
                                        <p><strong>Bank Account:</strong> {{ invoiceForm.bank_account_name }}</p>
                                        <p><strong>Bank Number:</strong> {{ invoiceForm.bank_account_number }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Service Details Section -->
                        <div class="service-table-container">
                            <table class="service-table">
                                <thead>
                                    <tr class="table-header">
                                        <th class="no-col">No</th>
                                        <th class="description-col">Description of Service</th>
                                        <th class="quantity-col">Product</th>
                                        <th class="rate-col">Price</th>
                                        <th class="total-col">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in invoiceForm.order_details" :key="item.id" class="table-row">
                                        <td class="no-col">{{ index + 1 }}</td>
                                        <td class="description-col">{{ item.name }}</td>
                                        <td class="quantity-col">{{ item.quantity }} Barang</td>
                                        <td class="rate-col">{{ formatCurrencyIDR(item.price) }}</td>
                                        <td class="total-col">{{ formatCurrencyIDR(item.total) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Terms and Conditions & Total Section -->
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <div class="terms-section">
                                    <h3 class="section-title">Terms and Conditions:</h3>
                                    <ul class="terms-list">
                                        <li>Payment is due upon receipt of this invoice.</li>
                                        <li>Late payments may incur additional charges.</li>
                                        <li>Shipping via {{ invoiceForm.shipping_name || 'Standard Shipping' }}.</li>
                                        <li>Courier service: {{ invoiceForm.courier_name || 'Regular Courier' }}.</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="total-calculation">
                                    <div class="subtotal-row">
                                        <span class="label">Subtotal</span>
                                        <span class="amount">{{ formatCurrencyIDR(calculateSubtotal()) }}</span>
                                    </div>
                                    <div class="subtotal-row">
                                        <span class="label">Courier</span>
                                        <span class="amount">{{ formatCurrencyIDR(invoiceForm.shipping_cost) }}</span>
                                    </div>
                                    <div class="tax-row">
                                        <span class="label">Other Fee</span>
                                        <span class="amount">{{ formatCurrencyIDR(invoiceForm.fee_amount) }}</span>
                                    </div>
                                    <div class="total-row">
                                        <span class="label"><strong>Total Amount Due</strong></span>
                                        <span class="amount"><strong>{{ formatCurrencyIDR(invoiceForm.grand_total) }}</strong></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Payment Information Section -->
                        <div class="payment-info-section">
                            <h3 class="section-title-white">Payment Information:</h3>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="payment-details">
                                        <p><strong>Payment Method:</strong> {{ invoiceForm.bank_name || 'Bank Transfer' }}</p>
                                        <p><strong>Due Date:</strong> {{ formatDate(invoiceForm.transaction_date) }}</p>
                                        <p><strong>Bank Account:</strong> {{ invoiceForm.bank_account_number || '1234-5678-9012-3456' }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6 text-end">
                                    <div class="signature-section">
                                        <p class="date-text">Date: {{ formatDate(invoiceForm.transaction_date) }}</p>
                                        <div class="signature-line"></div>
                                        <p class="signature-name">{{ invoiceForm.sales_name }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeInvoiceModal">Close</button>
                    <button type="button" class="btn btn-success" @click="printInvoiceToPDF" :disabled="printLoading">
                        <i class="fa fa-file-pdf-o" v-if="!printLoading"></i>
                        <i class="fa fa-spinner fa-spin" v-else></i>
                        {{ printLoading ? 'Generating...' : 'Download PDF' }}
                    </button>
                    <button type="button" class="btn btn-info" @click="printInvoiceToPNG" :disabled="printLoading">
                        <i class="fa fa-download" v-if="!printLoading"></i>
                        <i class="fa fa-spinner fa-spin" v-else></i>
                        {{ printLoading ? 'Generating...' : 'Download PNG' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, defineAsyncComponent } from 'vue'
const WelcomeView = defineAsyncComponent(() => import("@/components/widget/card/WelcomeView.vue"))
const Card1 = defineAsyncComponent(() => import("@/components/common/card/CardData1.vue"))
const Upload = defineAsyncComponent(() => import("@/components/input/Uploads.vue"))
import * as sales from "@/api/services/SalesRequest";
import DataTable from '@/components/table/DatatableDateRange.vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import { GoogleMap, Marker } from 'vue3-google-map'
import { useSessionStore } from '@/store/session';
const session = useSessionStore()
const user = ref([] as any[])
const stats = ref([
    { label: 'Total Order', value: 0 },
    { label: 'Order QTY', value: 0 },
    { label: 'Pendapatan', value: 0 }
])
const headers = [
    { text: 'Order No', value: 'code' },
    { text: 'Transaction Date', value: 'transaction_date' },
    { text: 'Divisi', value: 'divisi' },
    { text: 'Customer', value: 'customer' },
    { text: 'Payment', value: 'payment' },
    { text: 'Shipping', value: 'shipping_name' },
    { text: 'Courier', value: 'courier_name' },
    { text: 'Status', value: 'order_status' },
    { text: 'Resi', value: 'waybill_no' },
    { text: 'QTY', value: 'qty_total' },
    { text: 'Grand Total', value: 'grand_total' },
]
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: ''
})
const orderHistory = ref<any>([])
const loading = ref(false)
const total = ref(0)

const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchOrder()
    fetchDashboardAllSales()
}
let selectedOrder = reactive<any>({})
const googleMapsApiKey = (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined) || ''
const showLocationModal = ref(false)
const tempLat = ref<number | null>(null)
const tempLng = ref<number | null>(null)
const mapCenter = ref<{ lat: number, lng: number }>({ lat: -6.200000, lng: 106.816666 })
const mapZoom = ref(13)
const addressQuery = ref('')

import { Modal } from 'bootstrap'
const modalRef = ref<HTMLElement | null>(null) // Type the ref
let bsModal: any | null = null // Type the bootstrap modal instance as any since Modal namespace can't be used directly
function informationOrder(item: any) {
    Object.assign(selectedOrder, item);
    if (!selectedOrder.locations && selectedOrder.customer_address) {
        addressQuery.value = selectedOrder.customer_address
    }
    if (bsModal) {
        bsModal.show()
    }
}

function printWa() {
    loading.value = true
    if (selectedOrder) {
        let reportWhatsapp = "";
        reportWhatsapp += "\r\n *LAPORAN PEMESANAN  " + selectedOrder.shipping_name.toUpperCase() + "*";
        // reportWhatsapp += "\r\n *Divisi  : " + selectedOrder.divisi_name.toUpperCase() + "*";
        reportWhatsapp += "\r\n *Divisi Team  : " + selectedOrder.divisi_team_name.toUpperCase() + "*";
        reportWhatsapp += "\r\n *IKLAN  : " + selectedOrder.interaction_name + "*";
        reportWhatsapp += "\r\n *Tanggal  : " + formatDateTime(selectedOrder.transaction_date) + "*";
        reportWhatsapp += "\r\n ";
        reportWhatsapp += "\r\n *TANGGAL ORDER KE ADMIN:*";
        reportWhatsapp += "\r\n *" + formatDate(new Date().toISOString()) + "*";
        reportWhatsapp += "\r\n *JAM ORDER KE ADMIN:*";
        reportWhatsapp += "\r\n *" + new Date().toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jakarta' }) + " WIB*";
        reportWhatsapp += "\r\n ";
        reportWhatsapp += "\r\n *Berikut data pengiriman pemesanan customer:*";
        reportWhatsapp += "\r\n -Nama Pembeli: " + selectedOrder.customer_name;
        reportWhatsapp += "\r\n -No. Telp: " + selectedOrder.customer_phone;
        reportWhatsapp += "\r\n -Alamat: " + selectedOrder.customer_address;
        reportWhatsapp += "\r\n";
        reportWhatsapp += "\r\n *Berikut data Pesanan: " + (selectedOrder.order_details && selectedOrder.order_details[0] ? selectedOrder.order_details[0].name : 'N/A') + "*";
        reportWhatsapp += "\r\n -No. Pesanan : " + selectedOrder.code;
        reportWhatsapp += "\r\n -Jumlah Pemesanan : " + formatSeparator(selectedOrder.order_details && selectedOrder.order_details[0] ? selectedOrder.order_details[0].quantity : 0);
        reportWhatsapp += "\r\n -Biaya Diskon : " + formatSeparator(selectedOrder.order_details && selectedOrder.order_details[0] ? selectedOrder.order_details[0].discount : 0);
        reportWhatsapp += "\r\n -Biaya Pengiriman : " + formatSeparator(selectedOrder.shipping_cost || 0);
        reportWhatsapp += "\r\n -Biaya Penanganan : " + formatSeparator(selectedOrder.fee_amount || 0);
        reportWhatsapp += "\r\n -Total Pembayaran : " + formatSeparator(selectedOrder.grand_total);
        reportWhatsapp += "\r\n -Bank   : " + selectedOrder.bank_name;
        reportWhatsapp += "\r\n -Jenis transaksi : " + selectedOrder.payment;
        reportWhatsapp += "\r\n -Kurir Pengiriman : " + selectedOrder.courier_name;
        reportWhatsapp += "\r\n -Tanggal Order : " + formatDateTime(selectedOrder.transaction_date);
        reportWhatsapp += "\r\n -No. Resi: " + (selectedOrder.waybill_no || 'N/A');
        reportWhatsapp += "\r\n -Status Pemesanan: " + selectedOrder.order_status;
        reportWhatsapp += "\r\n ";
        reportWhatsapp += "\r\n ";
        reportWhatsapp += "\r\n *CS YANG MENGAJUKAN CS "+ selectedOrder.divisi_team_name.toUpperCase()+"*";
        reportWhatsapp += "\r\n Nama : "+selectedOrder.sales_name;
        reportWhatsapp += "\r\n ";
        reportWhatsapp += "\r\n *ACC*";
        reportWhatsapp += "\r\n ADMIN PRODUK ";
        reportWhatsapp += "\r\n Nama : " + selectedOrder.approval_by;
        reportWhatsapp += "\r\n ";
        reportWhatsapp += "\r\n *MENGETAHUI*";
        reportWhatsapp += "\r\n FINANCE";
        reportWhatsapp += "\r\n ";
        // reportWhatsapp += "\r\n ";
        // reportWhatsapp += "\r\n *YANG BERTANGGUNG JAWAB*";  
        // reportWhatsapp += "\r\n DIREKTUR " ;
        // reportWhatsapp += "\r\n BU IRA " ;
        reportWhatsapp += "\r\n " ;


        // Create temporary textarea element
        const tempTextArea = document.createElement('textarea');
        const modalElement = document.getElementById('orderModal');
        if (modalElement) {
            // tempTextArea.style.cssText = 'position: fixed; left: -9999px; top: 0';
            tempTextArea.setAttribute('readonly', ''); // Prevent mobile keyboard from showing
            modalElement.appendChild(tempTextArea);
            tempTextArea.value = reportWhatsapp;

            // Copy text
            tempTextArea.focus();
            tempTextArea.select();
        }
        try {
            document.execCommand('copy');
            toast.success('Copy Success');
        } catch (err) {
            toast.warning('Oops, unable to copy');
        }
        // Clean up
        if (modalElement && tempTextArea) {
            modalElement.removeChild(tempTextArea);
        }
    }
    loading.value = false
}

function formatDateTime(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
}
function formatCurrency(value: number) {
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
    }).format(value);
}

function formatSeparator(value: number): string {
    return new Intl.NumberFormat('id-ID', {
        style: 'decimal',
        minimumFractionDigits: 0
    }).format(value);
}

async function fetchOrder() {
    loading.value = true
    await sales.postRequest("/order/list", { ...params, email: session.getUser().email }).then((res) => {
        if (res.status == 200 && res.data) {
            orderHistory.value = res.data
            total.value = res.total
        } else {
            orderHistory.value = []
            total.value = 0
        }
    })
    loading.value = false
}

async function fetchDashboardAllSales() {
    user.value = []
    await sales.postRequest("/dashboard/sales-all", { ...params, email: session.getUser().email }).then((res) => {
        if (res.status == 200 && res.data) {
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    let dt = res.data[i];
                    // try {
                    //     dt.sales = JSON.parse(dt.sales)
                    // } catch (e) {
                    //     console.error("Failed to parse sales data:", e);
                    //     continue;
                    // }

                    if (dt.sales_email === session.getUser().email) {
                        stats.value = [
                            { label: 'Total Order', value: dt.total_orders },
                            { label: 'Order QTY', value: dt.total_qty },
                            { label: 'Total Pendapatan', value: dt.grand_total }
                        ]
                    }
                    user.value.push(dt)
                }
            }
        }
    })
}

async function processOrder() {
    await sales.postRequest("/order/upload-payment", { ID: selectedOrder.ID, payment_image: selectedOrder.payment_image, sales_email: selectedOrder.sales_email, locations: selectedOrder.locations })
    selectedOrder.value = null
    closeModal()
    fetchOrder()
}

function parseLocation(value: string): { lat: number | null, lng: number | null } {
    if (!value) return { lat: null, lng: null }
    const parts = value.split(',').map((v: string) => v.trim())
    if (parts.length < 2) return { lat: null, lng: null }
    const lat = Number(parts[0])
    const lng = Number(parts[1])
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return { lat: null, lng: null }
    return { lat, lng }
}

function openLocationModal() {
    const parsed = parseLocation(selectedOrder.locations || '')
    tempLat.value = parsed.lat
    tempLng.value = parsed.lng
    addressQuery.value = selectedOrder.customer_address || ''
    if (tempLat.value != null && tempLng.value != null) {
        mapCenter.value = { lat: tempLat.value, lng: tempLng.value }
        mapZoom.value = 16
    }
    showLocationModal.value = true
    if (tempLat.value == null && tempLng.value == null && addressQuery.value) {
        searchAddress(true)
    }
}

function closeLocationModal() {
    showLocationModal.value = false
}

function applyLocation() {
    if (tempLat.value == null || tempLng.value == null) {
        selectedOrder.locations = ''
        showLocationModal.value = false
        return
    }
    selectedOrder.locations = `${tempLat.value},${tempLng.value}`
    showLocationModal.value = false
}

function centerToTemp() {
    if (tempLat.value == null || tempLng.value == null) return
    mapCenter.value = { lat: tempLat.value, lng: tempLng.value }
    mapZoom.value = 16
}

function onMapClick(e: any) {
    const lat = e?.latLng?.lat?.()
    const lng = e?.latLng?.lng?.()
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return
    tempLat.value = Number(lat)
    tempLng.value = Number(lng)
}

async function searchAddress(silent: boolean = false) {
    if (!addressQuery.value) return
    if (!googleMapsApiKey) {
        if (!silent) toast.error('Google Maps API Key belum diset')
        return
    }
    const googleObj = (window as any).google
    if (!googleObj?.maps?.Geocoder) {
        if (silent) {
            retrySearchAddress(10)
            return
        }
        toast.error('Google Maps belum siap')
        return
    }

    const geocoder = new googleObj.maps.Geocoder()
    geocoder.geocode({ address: addressQuery.value }, (results: any, status: any) => {
        if (status !== 'OK' || !results || results.length === 0) {
            if (!silent) toast.error('Alamat tidak ditemukan')
            return
        }
        const loc = results[0]?.geometry?.location
        const lat = loc?.lat?.()
        const lng = loc?.lng?.()
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
            if (!silent) toast.error('Koordinat tidak valid')
            return
        }
        tempLat.value = Number(lat)
        tempLng.value = Number(lng)
        mapCenter.value = { lat: tempLat.value, lng: tempLng.value }
        mapZoom.value = 16
    })
}

function retrySearchAddress(triesLeft: number) {
    if (triesLeft <= 0) return
    setTimeout(() => {
        const googleObj = (window as any).google
        if (googleObj?.maps?.Geocoder) {
            searchAddress(true)
            return
        }
        retrySearchAddress(triesLeft - 1)
    }, 250)
}

const closeModal = () => {
    if (bsModal) { // Check if bsModal is initialized
        bsModal.hide()
    }
}

// Image upload handler
const handleImageUpload = (event: string) => {
    selectedOrder.payment_image = event as string;
}

// Invoice related functionality
const invoiceForm = reactive<any>({})
const invoiceModalRef = ref<HTMLElement | null>(null)
let invoiceModal: any | null = null
const printLoading = ref(false)

function openInvoiceModal(item: any) {
    Object.assign(invoiceForm, item)
    if (invoiceModal) {
        invoiceModal.show()
    }
}

function closeInvoiceModal() {
    if (invoiceModal) {
        invoiceModal.hide()
    }
}

function formatDate(dateString: string): string {
    if (!dateString) return ''
    const date = new Date(dateString)
    const dd = String(date.getDate()).padStart(2, '0')
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const yyyy = date.getFullYear()
    return `${dd}-${mm}-${yyyy}`
}

function formatCurrencyIDR(value: number): string {
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
    }).format(value)
}

function calculateSubtotal(): number {
    if (!invoiceForm.order_details) return 0
    return invoiceForm.order_details.reduce((sum: number, item: any) => sum + item.total, 0)
}

async function printInvoiceToPNG() {
    printLoading.value = true
    try {
        const html2canvas = (await import('html2canvas')).default
        
        // Create temporary container for printing
        const printContainer = document.createElement('div')
        printContainer.style.cssText = `
            position: absolute;
            top: -9999px;
            left: -9999px;
            width: 900px;
            min-height: 1200px;
            background: white;
            padding: 20px;
            font-family: Arial, sans-serif;
        `
        
        // Clone the invoice content
        const invoiceContent = document.getElementById('invoice-content')
        if (invoiceContent) {
            const clonedContent = invoiceContent.cloneNode(true) as HTMLElement
            
            // Apply specific styles for PNG export
            const logoImg = clonedContent.querySelector('.company-logo-img') as HTMLImageElement
            if (logoImg) {
                logoImg.style.maxHeight = '60px'
                logoImg.style.maxWidth = '150px'
                logoImg.style.objectFit = 'contain'
                logoImg.style.display = 'block'
                logoImg.style.marginLeft = 'auto'
                logoImg.style.visibility = 'visible'
                logoImg.style.opacity = '1'
                
                // Wait for image to load
                await new Promise((resolve) => {
                    if (logoImg.complete) {
                        resolve(true)
                    } else {
                        logoImg.onload = () => resolve(true)
                        logoImg.onerror = () => resolve(true)
                    }
                })
            }
            
            printContainer.appendChild(clonedContent)
            document.body.appendChild(printContainer)
            
            // Generate canvas
            const canvas = await html2canvas(printContainer, {
                width: 900,
                height: 1200,
                scale: 2,
                useCORS: true,
                allowTaint: true
            })
            
            // Download as PNG
            const link = document.createElement('a')
            link.download = `invoice-${invoiceForm.code || 'unknown'}.png`
            link.href = canvas.toDataURL()
            link.click()
            
            // Clean up
            document.body.removeChild(printContainer)
        }
    } catch (error) {
        console.error('Error generating PNG:', error)
        toast.error('Failed to generate PNG')
    } finally {
        printLoading.value = false
    }
}

async function printInvoiceToPDF() {
    printLoading.value = true
    try {
        const html2canvas = (await import('html2canvas')).default
        const jsPDF = (await import('jspdf')).default
        
        // Create temporary container for printing
        const printContainer = document.createElement('div')
        printContainer.style.cssText = `
            position: absolute;
            top: -9999px;
            left: -9999px;
            width: 794px;
            min-height: 1123px;
            background: white;
            padding: 20px;
            font-family: Arial, sans-serif;
        `
        
        // Clone the invoice content
        const invoiceContent = document.getElementById('invoice-content')
        if (invoiceContent) {
            const clonedContent = invoiceContent.cloneNode(true) as HTMLElement
            
            // Apply specific styles for PDF export
            const logoImg = clonedContent.querySelector('.company-logo-img') as HTMLImageElement
            if (logoImg) {
                logoImg.style.maxHeight = '80px'
                logoImg.style.maxWidth = '180px'
                logoImg.style.objectFit = 'contain'
                logoImg.style.display = 'block'
                logoImg.style.marginLeft = 'auto'
                logoImg.style.visibility = 'visible'
                logoImg.style.opacity = '1'
                
                // Wait for image to load
                await new Promise((resolve) => {
                    if (logoImg.complete) {
                        resolve(true)
                    } else {
                        logoImg.onload = () => resolve(true)
                        logoImg.onerror = () => resolve(true)
                    }
                })
            }
            
            printContainer.appendChild(clonedContent)
            document.body.appendChild(printContainer)
            
            // Generate canvas
            const canvas = await html2canvas(printContainer, {
                width: 794,
                height: 1123,
                scale: 2,
                useCORS: true,
                allowTaint: true
            })
            
            // Create PDF
            const pdf = new jsPDF('p', 'mm', 'a4')
            const imgData = canvas.toDataURL('image/png')
            
            // Calculate dimensions for A4
            const pdfWidth = pdf.internal.pageSize.getWidth()
            const pdfHeight = pdf.internal.pageSize.getHeight()
            const imgWidth = pdfWidth
            const imgHeight = (canvas.height * pdfWidth) / canvas.width
            
            // Add image to PDF
            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, Math.min(imgHeight, pdfHeight))
            
            // Save PDF
            pdf.save(`invoice-${invoiceForm.code || 'unknown'}.pdf`)
            
            // Clean up
            document.body.removeChild(printContainer)
        }
    } catch (error) {
        console.error('Error generating PDF:', error)
        toast.error('Failed to generate PDF')
    } finally {
        printLoading.value = false
    }
}

onMounted(() => {
    // Initialize order modal
    if (modalRef.value) {
        bsModal = new Modal(modalRef.value)
    }
    
    // Initialize invoice modal
    if (invoiceModalRef.value) {
        invoiceModal = new Modal(invoiceModalRef.value)
    }
    
    // Fetch initial data
    fetchOrder()
    fetchDashboardAllSales()
})

</script>

<style scoped>
.zoomed {
    transform: scale(100);
    transition: transform 0.3s ease;
}

/* Waybill Styles */
.waybill-container {
    background: white;
    padding: 12px;
    font-family: Arial, sans-serif;
    color: #000;
    width: 576px;
    height: 384px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* Modal view specific styles */
.waybill-modal-view {
    width: 100% !important;
    height: auto !important;
    min-height: 384px;
    max-width: 800px;
    margin: 0 auto;
    overflow: visible !important;
}

.waybill-modal-view .waybill-header h3,
.waybill-modal-view .waybill-header h4 {
    font-size: 16px;
}

.waybill-modal-view .sender-info h5,
.waybill-modal-view .receiver-info h5,
.waybill-modal-view .package-info h5 {
    font-size: 14px;
}

.waybill-modal-view .sender-info p,
.waybill-modal-view .receiver-info p {
    font-size: 12px;
}

.waybill-modal-view .package-info table {
    font-size: 12px;
}

.waybill-modal-view .package-info th,
.waybill-modal-view .package-info td {
    font-size: 12px;
    padding: 8px;
}

.waybill-modal-view .shipping-info p,
.waybill-modal-view .cost-summary p {
    font-size: 12px;
}

.waybill-modal-view .signature-box p {
    font-size: 11px;
}

.waybill-modal-view .waybill-footer p {
    font-size: 11px;
}

.waybill-header {
    border-bottom: 2px solid #000;
    padding-bottom: 8px;
    margin-bottom: 12px;
}

.waybill-header h3 {
    margin: 0;
    font-weight: bold;
    font-size: 14px;
}

.waybill-header h4 {
    margin: 0;
    font-weight: bold;
    font-size: 12px;
}

.sender-info,
.receiver-info {
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 3px;
    background-color: #f9f9f9;
    margin-bottom: 8px;
}

.sender-info h5,
.receiver-info h5 {
    margin-top: 0;
    margin-bottom: 5px;
    color: #333;
    font-weight: bold;
    font-size: 10px;
}

.sender-info p,
.receiver-info p {
    margin: 2px 0;
    font-size: 9px;
    line-height: 1.2;
}

.package-info h5 {
    margin-bottom: 8px;
    color: #333;
    font-weight: bold;
    font-size: 10px;
}

.package-info table {
    margin-bottom: 8px;
    font-size: 8px;
}

.package-info th,
.package-info td {
    padding: 3px;
    font-size: 8px;
}

.package-info th {
    background-color: #f8f9fa;
    font-weight: bold;
}

.shipping-info {
    border: 1px solid #ddd;
    padding: 8px;
    border-radius: 3px;
    background-color: #f8f9fa;
    margin-bottom: 8px;
}

.shipping-info p {
    margin: 2px 0;
    font-size: 9px;
}

.signature-box {
    text-align: center;
    border: 1px solid #ccc;
    padding: 0px;
    border-radius: 3px;
    background-color: #f9f9f9;
}

.signature-line {
    border-bottom: 1px solid #000;
    margin: 20px 10px 5px 10px;
    height: 1px;
}

.signature-box p {
    font-size: 8px;
    margin: 2px 0;
}

.waybill-footer {
    border-top: 1px solid #ddd;
    padding-top: 8px;
}

.waybill-footer p {
    font-size: 8px;
    margin: 2px 0;
}

/* Landscape specific optimizations */
.waybill-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.cost-summary p {
    margin: 1px 0;
    font-size: 9px;
}

.d-flex.justify-content-between {
    align-items: flex-start;
}

.signature-box {
    min-height: 60px;
}

/* Print specific styles */
@media print {
    .waybill-container {
        box-shadow: none;
        border: none;
    }
}

.waybill-modal-view .package-info th,
.waybill-modal-view .package-info td {
    font-size: 12px;
    padding: 0px;
}

/* Invoice Styles - Following Design Studio Template */
.invoice-container {
    background: white;
    padding: 0;
    font-family: 'Arial', sans-serif;
    color: #333;
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
}

/* Header with teal background */
.invoice-header-bg {
    background: linear-gradient(135deg, #4a9b8e 0%, #2c5f5a 100%);
    color: white;
    padding: 30px;
    margin: -20px -20px 0 -20px;
}

.invoice-header-content {
    max-width: 100%;
}

.invoice-main-title {
    font-size: 3rem;
    font-weight: bold;
    margin: 0;
    color: white;
}

.company-logo {
    display: flex;
    align-items: center;
    gap: 15px;
}

.logo-icon {
    background: #f39c12;
    color: white;
    width: 60px;
    height: 60px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    text-transform: lowercase;
}

.logo-text {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
}

.design-text {
    font-size: 24px;
    font-weight: bold;
    color: white;
}

.studio-text {
    font-size: 24px;
    font-weight: normal;
    color: white;
}

/* Invoice details section */
.invoice-details-section {
    padding: 30px;
    border-bottom: 1px solid #eee;
}

.invoice-number,
.invoice-date {
    margin-bottom: 8px;
    font-size: 14px;
}

.company-details p {
    margin-bottom: 5px;
    font-size: 14px;
}

/* Bill To Section */
.bill-to-section {
    padding: 30px;
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #eee;
}

.section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
}

.client-info p,
.payment-info p {
    margin-bottom: 8px;
    font-size: 14px;
}

.client-name,
.company-name {
    font-weight: 600;
}

/* Service Details Section */
.service-details-section {
    padding: 30px;
    border-bottom: 1px solid #eee;
}

.service-table-container {
    margin-top: 20px;
}

.service-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

.service-table .table-header {
    background-color: #f39c12;
    color: white;
}

.service-table th {
    padding: 15px 10px;
    text-align: left;
    font-weight: bold;
    border: none;
}

.service-table .no-col {
    width: 8%;
    text-align: center;
}

.service-table .description-col {
    width: 40%;
}

.service-table .quantity-col {
    width: 17%;
    text-align: center;
}

.service-table .rate-col {
    width: 17%;
    text-align: right;
}

.service-table .total-col {
    width: 18%;
    text-align: right;
}

.service-table .table-row {
    background-color: #f8f9fa;
}

.service-table .table-row:nth-child(even) {
    background-color: white;
}

.service-table td {
    padding: 12px 10px;
    border-bottom: 1px solid #dee2e6;
    vertical-align: middle;
}

/* Terms and Total Section */
.terms-section {
    padding: 20px 0;
}

.terms-list {
    list-style-type: disc;
    padding-left: 20px;
    margin: 0;
}

.terms-list li {
    margin-bottom: 8px;
    font-size: 14px;
}

.total-calculation {
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    margin-top: 20px;
}

.subtotal-row,
.tax-row,
.total-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    padding: 8px 0;
}

.total-row {
    border-top: 2px solid #333;
    margin-top: 15px;
    padding-top: 15px;
    font-size: 18px;
}

/* Payment Information Section */
.payment-info-section {
    background-color: #2c5f5a;
    color: white;
    padding: 30px;
    margin: 0 -20px;
}

.section-title-white {
    font-size: 20px;
    font-weight: bold;
    color: white;
    margin-bottom: 20px;
}

.payment-details p {
    margin-bottom: 8px;
    font-size: 14px;
    color: white;
}

.signature-section {
    text-align: right;
}

.date-text {
    margin-bottom: 30px;
    font-size: 14px;
    color: white;
}

.signature-line {
    border-bottom: 2px solid white;
    width: 200px;
    margin: 20px 0 10px auto;
}

.signature-name {
    font-size: 14px;
    color: white;
    margin: 0;
}

/* Questions Section */
.questions-section {
    padding: 30px;
    background-color: #f8f9fa;
    margin: 0 -20px -20px -20px;
}

.contact-info p {
    margin-bottom: 5px;
    font-size: 14px;
}

/* Print specific styles for invoice */
@media print {
    .invoice-container {
        box-shadow: none;
        border: none;
        padding: 0;
    }
    
    .modal-header,
    .modal-footer {
        display: none !important;
    }
    
    .modal-body {
        padding: 0 !important;
    }
}
</style>
